export default __webpack_public_path__ + "static/media/script-trimmed-macos.ebe90da3.avif";